export default "__VITE_ASSET__01311e8e__"